// 회색 박스 공통 스타일
export const InputStyle = ` 
padding: 15px;
background-color: var(--grey);
border-radius: 4px;
margin-bottom: 15px;
font-size: 18px;
`;

// 이미지 공통 스타일
export const ImgStyle = `
display: block;
width: 100%;
height: 100%;
object-fit: cover;`;
